import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';




class WebComponent extends HTMLElement {
  connectedCallback() {
    const root = ReactDOM.createRoot(this);
    root.render(<App />);
  }
}
const ELEMENT_ID = 'branch-locator';

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
} 
